// extracted by mini-css-extract-plugin
module.exports = {"tabsIndicator":"VIP_StandardTabBar__tabsIndicator","tabSelected":"VIP_StandardTabBar__tabSelected"};